import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "card-repeat--sprite",
  "use": "card-repeat--sprite-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol viewBox=\"0 0 12 12\" xmlns=\"http://www.w3.org/2000/svg\" id=\"card-repeat--sprite\">\n<path d=\"M10 8.585L9.415 8H2V2H10V8.585ZM10 1H2C1.45 1 1 1.45 1 2V8C1 8.55 1.45 9 2 9H9L11 11V2C11 1.45 10.55 1 10 1Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol